export const PrintAction = {
    Ready: "print.ready",
    Failed: "print.failed",
    Prepare: "print.prepare",
    Print: "print.trigger",
};
